import { mapState, mapActions } from 'vuex';

export default {
  data() {
    return {
      infiniteLoadingId: 0,
      validacao: {
        tipo: [
          { required: true, message: "Tipo é obrigatório" }
        ]
      },
      
      tabSelecionada: 'detalhes',

      hoverGravar: false,
      hoverRemover: false,
    };
  },
  computed: {
    ...mapState('loginStore', {
      permissoes(state) {
        return state.usuarioLogado.permissoes
          .filter((permissao) => {
            return permissao.modulo === "PLACAS";
          })[0];
      }
    }),
    ...mapState('placasStore', {
      placas(state) { return state.listaPlacas; },
      placaPesquisa(state) { return state.placaPesquisa; },
      labelQuantidade(state) { return state.labelQuantidade; },
      placa(state) { return state.placaSelecionada; }
    }),
    exibirPlacas() {
      return this.permissoes.visualizacao;
    },
    exibirBotaoGravarPlaca() {
      return(
        (this.placa.id === 0 && this.permissoes.cadastro)
        || (this.placa.id !== 0 && this.permissoes.alteracao)
      )
    },
    exibirBotaoRemoverPlaca() {
      return this.placa.id !== 0 && this.permissoes.remocao;
    },
    exibirCampoQuantidadeUtilizada() {
      return this.placa.id !== 0;
    }
  },
  methods: {
    ...mapActions([
      'showLoading',
      'hideLoading'
    ]),
    ...mapActions('placasStore', [
      'listarPlacas',
      'limparPlacasListadas',
      'limparPlacaPesquisa',
      'recuperarPlaca',
      'novaPlaca',
      'gravarPlaca',
      'removerPlaca'
    ]),
    pesquisar($state) {
      if(this.placaPesquisa.pagina === 0) { this.showLoading(); }
      this.listarPlacas(this.placaPesquisa)
        .then((resultado) => {
          if(this.placaPesquisa.pagina === 0) { this.hideLoading(); }
          if(resultado.lista.length === 100) {
            this.placaPesquisa.pagina += 1;
            $state.loaded();
          } else if(resultado.lista.length > 0 && this.placaPesquisa.pagina === 0) {
            $state.loaded();
            $state.complete();
          } else {
            $state.complete();
          }
        }).catch(() => {
          if(this.placaPesquisa.pagina === 0) { this.hideLoading(); }
          this.$message.error("Não foi possível conectar-se ao servidor");
        });
    },
    pesquisarHandler() {
      this.placaPesquisa.pagina = 0;
      this.limparPlacasListadas();
      this.infiniteLoadingId += 1;
    },
    novaPlacaHandler() {
      this.$refs["formPlaca"].resetFields();
      this.novaPlaca();
    },
    limparPesquisa() {
      this.limparPlacaPesquisa();
    },
    selecionarTab(tab) {
      if(tab.name === 'logs') {
        this.handleRecuperarLogs();
      }
    },
    recuperarHandler(placa) {
      this.recuperar(placa);
    },
    recuperar(placa) {
      this.showLoading();
      this.recuperarPlaca(placa).then(() => {
        this.hideLoading();
      }).catch(() => {
        this.hideLoading();
        this.$message.error("Não foi possível conectar-se ao servidor");
      });
    },
    gravarHandler() {
      this.$refs['formPlaca'].validate((valid) => {
        if(valid) {
          this.gravar();
        } else {
          this.exibirAlert("Atenção", "Preencha todos os campos obrigatórios");
        }
      });
    },
    gravar() {
      this.showLoading();
      this.gravarPlaca(this.placa).then((resultado) => {
        this.hideLoading();
        switch(resultado.status) {
          case "ERRO":
            this.$message.error(resultado.mensagem);
            break;
          case "SUCESSO":
            this.$message.success(resultado.mensagem);
            this.pesquisarHandler();
        }
      }).catch(() => {
        this.hideLoading();
        this.$message.error("Não foi possível conectar-se ao servidor");
      });
    },
    exibirAlert(titulo, mensagem) {
      this.$alert(mensagem, titulo, { confirmButtonText: "OK" });
    },
    removerContaHandler() {
      this.$confirm("Deseja realmente remover esta Placa?", "Atenção", {
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        type: "warning"
      }).then(() => {
        this.remover();
      });
    },
    remover() {
      this.showLoading();
      this.removerPlaca(this.placa).then((resultado) => {
        this.hideLoading();
        switch(resultado.status) {
          case "ERRO":
            this.$message.error(resultado.mensagem);
            break;
          case "SUCESSO":
            this.$message.success(resultado.mensagem);
            this.pesquisarHandler();
        }
      }).catch(() => {
        this.hideLoading();
        this.$message.error("Não foi possível conectar-se ao servidor");
      });
    }
  }
};